import React, {useState, useEffect} from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Collapse,
  Form,
  Button,
  Alert,
} from "react-bootstrap";
import ContactUsService from "services/contact-us";
import imageIcon from "../../assets/icons/fort_logo/icon.png";

const initialState = {
  name: "",
  contact_number: "",
  email: "",
  subject: "",
  message: "",
};

function ContactUs() {
  // Set the expandInfo values based on the screen size
  const [inputs, setInputs] = useState({...initialState});
  const [errors, setErrors] = useState({...initialState});

  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const handleChange = (e) => {
    const {name, value} = e.target;
    setInputs((prev) => ({...prev, [name]: value}));
    validateInput(e);
  };
  console.log({errors, error, successMsg});

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isError = false;
    for (const [key, value] of Object.entries(inputs)) {
      const errorMsg = validate(key, value);
      setErrors((prev) => ({...prev, [key]: errorMsg}));

      if (errorMsg?.length > 0) isError = true;
      // if (value.length !== 0 ) newPostData = { ...newPostData, [key]: value };
    }

    // Check for errors

    if (isError) return;
    try {
      const response = await ContactUsService.sendMessage(inputs);
      console.log({response});

      setSuccessMsg(response.data.message);
      setError("");
      setInputs(initialState);
    } catch (error) {
      console.log(error);
      for (const [key, value] of Object.entries(error.response.data)) {
        if (key === "non_field_errors") {
          setError(value);
          setSuccessMsg("");
        } else setErrors((prev) => ({...prev, [key]: value}));
      }
      setSuccessMsg("");
    }
  };
  // const handleChange = e => {
  //   const { name, value, type } = e.target;
  //   let newValue = value;
  //   if (type === "number") newValue = parseFloat(value);

  //   // Use a callback to update each input change immediately
  //   setInputs(curInputs => ({ ...curInputs, [name]: newValue }));
  //   validateInput(e);
  // };
  const validateInput = (e) => {
    let {name, value} = e.target;
    const errorMsg = validate(name, value);
    setErrors((prev) => ({...prev, [name]: errorMsg}));
  };

  const validate = (name, value) => {
    let errorMsg = "";
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    switch (name) {
      case "name":
        if (value.length < 1) errorMsg = "Name is required";
        else if (value.length > 60)
          errorMsg = "Name cannot be longer than 60 characters";
        break;
      case "contact_number":
        if (value.length < 1) errorMsg = "Enter a valid number";
        else if (value.length > 15) errorMsg = "Enter a valid number";

        break;
      case "email":
        if (!value.match(validRegex)) errorMsg = "Enter a valid email address";

        break;
      case "subject":
        if (value.length < 1)
          errorMsg = "Subject is required, less than 100 characters";
        else if (value.length > 100)
          errorMsg = "Subject is required, less than 100 characters";

        break;
      case "message":
        if (value.length < 1) errorMsg = "Message is required";
        else if (value.length < 20)
          errorMsg = "Minimum length is 20 characters";

        break;
      default:
        break;
    }

    return errorMsg;
  };

  return (
    <section className="mx-2 mt-4 contact-us-section">
      {/* <Container className="d-flex justify-content-end">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.8609810960074!2d55.2764601!3d25.207910299999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f439f688fe9ff%3A0x43c25d95a77e0b93!2sDIFC%20Innovation%20Hub!5e0!3m2!1sen!2sua!4v1696245791419!5m2!1sen!2sua"
          style={{
            border: 0,
            width: "95vw",
            maxWidth: "500px",
            height: "60vh",

            maxHeight: "450px",
          }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </Container> */}
      <h3
        className="text-center mb-3 mt-5"
        style={{fontSize: "36px", lineHeight: "40px"}}
      >
        Contact Us
      </h3>
      <p
        className="text-center mb-3"
        style={{fontSize: "18px", lineHeight: "27px"}}
      >
        Any question or remarks? Just write us a message!
      </p>
      <Container className="mt-5">
        {/*<h3 className="text-center mb-3">Pricing</h3>*/}
        <Row className="justify-content-center">
          <Col md={7} sm={12} className="mb-4">
            <Card
              className="border-0"
              style={{
                borderRadius: "10px",
                height: "100%",
              }}
            >
              <Card.Body
                as="form"
                className="d-flex flex-column justify-content-between"
                onSubmit={handleSubmit}
              >
                <Container fluid className="d-flex flex-grow-1 flex-column">
                  <Row>
                    <Form.Group as={Col} sm={12} lg={6} className={`mb-3 `}>
                      <Form.Label className="d-flex ">
                        <small>Name</small>
                      </Form.Label>
                      <Form.Control
                        onChange={handleChange}
                        name="name"
                        value={inputs.name}
                      />
                      <p
                        className="text-danger pt-1"
                        style={{fontSize: "12px", lineHeight: "16px"}}
                      >
                        {errors.name}
                      </p>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} lg={6} className={`mb-3 `}>
                      <Form.Label className="d-flex ">
                        <small>Contact number</small>
                      </Form.Label>
                      <Form.Control
                        onChange={handleChange}
                        name="contact_number"
                        value={inputs.contact_number}
                      />
                      <p
                        className="text-danger pt-1"
                        style={{fontSize: "12px", lineHeight: "16px"}}
                      >
                        {errors.contact_number}
                      </p>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} lg={6} className={`mb-3 `}>
                      <Form.Label className="d-flex ">
                        <small>Email address</small>
                      </Form.Label>
                      <Form.Control
                        onChange={handleChange}
                        name="email"
                        value={inputs.email}
                      />
                      <p
                        className="text-danger pt-1"
                        style={{fontSize: "12px", lineHeight: "16px"}}
                      >
                        {errors.email}
                      </p>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} lg={6} className={`mb-3 `}>
                      <Form.Label className="d-flex ">
                        <small>Subject</small>
                      </Form.Label>
                      <Form.Control
                        onChange={handleChange}
                        name="subject"
                        value={inputs.subject}
                      />
                      <p
                        className="text-danger pt-1"
                        style={{fontSize: "12px", lineHeight: "16px"}}
                      >
                        {errors.subject}
                      </p>
                    </Form.Group>
                  </Row>
                  <Row className="flex-grow-1">
                    <Form.Group
                      as={Col}
                      sm={12}
                      className={`mb-3 flex-grow-1 d-flex  flex-column`}
                    >
                      <Form.Label className="d-flex">
                        <small>Message</small>
                      </Form.Label>
                      <Form.Control
                        onChange={handleChange}
                        name="message"
                        value={inputs.message}
                        as={"textarea"}
                        className="flex-grow-1"
                        style={{
                          whiteSpace: "pre-wrap",
                          height: "150px",
                          resize: "none",
                          overflowY: "auto",
                        }}
                      />
                      <p
                        className="text-danger pt-1"
                        style={{fontSize: "12px", lineHeight: "16px"}}
                      >
                        {errors.message}
                      </p>
                    </Form.Group>
                  </Row>
                </Container>
                <Row className="w-100 d-flex justify-content-end align-items-center p-0  form-actions-container m-0">
                  <Col
                    xs={12}
                    lg={8}
                    className="pe-0 ps-0 form-message-container"
                  >
                    {error && (
                      <Alert
                        variant="danger"
                        className="text-danger p-2 mb-0 mx-auto"
                        style={{
                          fontSize: "12px",
                          lineHeight: "16px",
                          textAlign: "center",
                          width: "fit-content",
                        }}
                      >
                        {error}
                      </Alert>
                    )}
                    {successMsg && (
                      <Alert
                        variant="success"
                        className="p-2 mb-0 mx-auto"
                        style={{
                          fontSize: "12px",
                          lineHeight: "16px",
                          textAlign: "center",
                          width: "fit-content",
                          color: "#24b91a",
                        }}
                      >
                        {successMsg}
                      </Alert>
                    )}
                  </Col>
                  <Col
                    xs={12}
                    lg={"auto"}
                    className="align-self-end p-0 action-container d-flex justify-content-center"
                  >
                    <Button
                      type="submit"
                      className="btn button-purple-gradient"
                    >
                      Send Message
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col md={5} sm={12} className="mb-4">
            <div className="w-100 h-100 d-flex flex-column justify-content-between">
              <Card
                className="border-0"
                style={{
                  margin: "0",
                }}
              >
                <Card.Body className="p-0">
                  <Row
                    className="h-100 overflow-hidden ms-0 me-0"
                    style={{borderRadius: "10px", background: "white"}}
                  >
                    <Col xs={12} lg={8} xl={7} xxl={6} className="p-3">
                      <h4 className="mb-4">Contact Information:</h4>
                      <div className="mt-4 mb-4">
                        <p>
                          <strong
                            className="me-2"
                            style={{letterSpacing: "1px", color: "#4b36a0"}}
                          >
                            <i className="bi bi-whatsapp"></i>
                          </strong>{" "}
                          <a
                            className="link-secondary"
                            style={{letterSpacing: "1px"}}
                            href="https://api.whatsapp.com/send?phone=971504716872"
                            target="_blank"
                          >
                            Click here
                          </a>
                        </p>
                        <p>
                          <strong
                            className="me-2"
                            style={{letterSpacing: "1px", color: "#4b36a0"}}
                          >
                            <i className="bi bi-telephone-inbound-fill"></i>
                          </strong>{" "}
                          <a
                            className="link-secondary"
                            style={{letterSpacing: "1px"}}
                            href="tel:+971504716872"
                          >
                            +971-50-4716872
                          </a>
                        </p>
                        <p>
                          <strong
                            className="me-2"
                            style={{letterSpacing: "1px", color: "#4b36a0"}}
                          >
                            <i className="bi bi-envelope-at-fill"></i>
                          </strong>{" "}
                          <a
                            className="link-secondary"
                            style={{letterSpacing: "1px"}}
                            href="mailto:info@fortinvestech.com"
                          >
                            info@fortinvestech.com
                          </a>
                        </p>
                      </div>
                    </Col>
                    <Col
                      xs={0}
                      lg={4}
                      xl={5}
                      xxl={6}
                      className="position-relative h-100 d-inline-block p-0 contact-info-img"
                      style={{minHeight: "100%"}}
                    >
                      <img
                        src={imageIcon}
                        // src="https://placehold.co/600x400"
                        alt="contact-us-img"
                        className="w-100 h-100"
                        style={{objectFit: "cover"}}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              {/*<div className="d-flex justify-content-end pt-5">*/}
              {/*  <iframe*/}
              {/*    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.8609810960074!2d55.2764601!3d25.207910299999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f439f688fe9ff%3A0x43c25d95a77e0b93!2sDIFC%20Innovation%20Hub!5e0!3m2!1sen!2sua!4v1696245791419!5m2!1sen!2sua"*/}
              {/*    style={{*/}
              {/*      border: 0,*/}
              {/*      width: "100%",*/}

              {/*      height: "300px",*/}
              {/*    }}*/}
              {/*    allowFullScreen=""*/}
              {/*    loading="lazy"*/}
              {/*    referrerPolicy="no-referrer-when-downgrade"*/}
              {/*  ></iframe>*/}
              {/*</div>*/}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ContactUs;
